
<template>
	<footer class="footer">
		<div class="content has-text-centered OrdersView__Copyrights">
			<p>Zaprojektowano dla {{ company.name }}, {{ company.address }}</p>
			<p>
				Route Planner @
				<a href="https://bluepear.pl" target="_blank">Agencja Interaktywna BluePear</a>
				© {{ currentYear }}
			</p>
		</div>
	</footer>
</template>

<script>
import config from '@/config'

export default {
	name: 'Footer',
	data() {
		return {
			company: config.company
		}
	},
	computed: {
		currentYear() {
			return new Date().getFullYear()
		}
	}
}
</script>

<style lang="scss" scoped>
.footer {
	padding: 1rem 1.5rem;
	p {
		font-size: 14px;
		&:last-child {
			margin-bottom: 0.5rem;
		}
	}
}
</style>
